import React from "react";
import "./footer.css";

const FooterPanel = () => {
  return (
    <div>
      <div class="copyrightText">
        <p>
          copyright &copy;2020|Designed By <span>Yash Verma</span> . All rights
          Reserved
        </p>
      </div>
    </div>
  );
};

export default FooterPanel;
